"use client";

import dynamic from "next/dynamic";

// Shared client-side async boundary for the nakshatra/pada studio (its graph
// carries the 54 KB nakshatra-page-presentation-data module). A dynamic() in a
// SERVER component does not dedupe — each route chunk group still gets a full
// copy (measured ×2 across /nakshatra and /nakshatra-calculator, 2026-08-22).
// From this ONE client module the import lands in a single async chunk that
// both routes load. Default ssr keeps the studio's crawlable SSR HTML intact.
const NakshatraStudioLazy = dynamic(() => import("./NakshatraStudio"));

export default NakshatraStudioLazy;
